import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PasteIcon(props: IconProps) {
    return <Icon {...props} iconKey={"paste"}/>
}
